import { createContext, useContext, useState } from "react";

const LanguageContext = createContext(null);

const translations = {
  en: {
    "nav.home": "Home",
    "nav.dashboard": "Dashboard",
    "nav.login": "Sign In",
    "nav.logout": "Sign Out",
    "nav.delete_account": "Delete Account",
    "nav.delete_account_confirm": "This action cannot be undone. All your data, bookings, and business information will be permanently deleted.",
    "landing.hero.overline": "THE UNIVERSAL BOOKING PLATFORM",
    "landing.hero.title": "Book appointments, effortlessly.",
    "landing.hero.subtitle": "One platform for every business. From doctors to hotels, mechanics to spas. Book, pay, done.",
    "landing.cta": "Get Started",
    "landing.cta.business": "Register Your Business",
    "landing.features.title": "Why BookEasy",
    "landing.features.booking": "Easy Booking",
    "landing.features.booking.desc": "Browse businesses, pick a time, book instantly with our shared calendar system.",
    "landing.features.payments": "Secure Payments",
    "landing.features.payments.desc": "Pay your deposit securely via Stripe. Your booking is guaranteed.",
    "landing.features.global": "Global Ready",
    "landing.features.global.desc": "Available in 5 languages. Works for businesses and customers worldwide.",
    "landing.features.categories": "Every Category",
    "landing.features.categories.desc": "Doctors, dentists, hotels, spas, mechanics, restaurants and more.",
    "landing.how.title": "How It Works",
    "landing.how.step1": "Create Account",
    "landing.how.step1.desc": "Sign up with Google in seconds.",
    "landing.how.step2": "Find & Book",
    "landing.how.step2.desc": "Search businesses, pick your date and time.",
    "landing.how.step3": "You're All Set!",
    "landing.how.step3.desc": "A small deposit secures your spot. Instant confirmation!",
    "cat.medical": "Medical",
    "cat.dental": "Dental",
    "cat.mechanic": "Mechanic",
    "cat.locksmith": "Locksmith",
    "cat.hotel": "Hotel",
    "cat.spa": "Spa",
    "cat.restaurant": "Restaurant",
    "cat.beauty": "Beauty",
    "cat.fitness": "Fitness",
    "cat.veterinary": "Veterinary",
    "cat.hairdresser": "Hairdresser",
    "cat.private_clinic": "Private Clinic",
    "cat.pizzeria": "Pizzeria / Takeaway",
    "cat.bar": "Bar / Pub",
    "cat.parking": "Parking",
    "cat.lawyer": "Lawyer",
    "cat.accountant": "Accountant",
    "cat.notary": "Notary",
    "cat.architect": "Architect",
    "cat.engineer": "Engineer",
    "cat.psychologist": "Psychologist",
    "cat.physiotherapist": "Physiotherapist",
    "cat.optician": "Optician",
    "cat.pharmacy": "Pharmacy",
    "cat.tailor": "Tailor",
    "cat.plumber": "Plumber",
    "cat.electrician": "Electrician",
    "cat.painter": "Painter",
    "cat.carpenter": "Carpenter",
    "cat.driving_school": "Driving School",
    "cat.photographer": "Photographer",
    "cat.florist": "Florist",
    "cat.bakery": "Bakery",
    "cat.butcher": "Butcher",
    "cat.ice_cream": "Ice Cream Shop",
    "cat.sushi": "Sushi Restaurant",
    "cat.kebab": "Kebab",
    "cat.takeaway_pizza": "Takeaway Pizza",
    "cat.coworking": "Coworking",
    "cat.laundry": "Laundry",
    "cat.pet_grooming": "Pet Grooming",
    "cat.tattoo": "Tattoo Studio",
    "cat.barber": "Barber",
    "cat.beach_club": "Beach Club",
    "cat.other": "Other",
    "cat.all": "All Categories",
    "role.title": "How will you use BookEasy?",
    "role.customer": "I want to book appointments",
    "role.customer.desc": "Find businesses and book services",
    "role.customer.label": "Customer",
    "role.business": "I have a business",
    "role.business.desc": "Manage appointments and accept bookings",
    "role.business.label": "Business",
    "biz.register.title": "Register Your Business",
    "biz.name": "Business Name",
    "biz.category": "Category",
    "biz.description": "Description",
    "biz.address": "Address",
    "biz.phone": "Phone",
    "biz.deposit": "Deposit Amount (EUR)",
    "biz.submit": "Register Business",
    "biz.dashboard.title": "Business Dashboard",
    "biz.bookings": "Bookings",
    "biz.availability": "Availability",
    "biz.settings": "Settings",
    "biz.today": "Today's Bookings",
    "biz.total": "Total Bookings",
    "biz.no_bookings": "No bookings yet",
    "cust.dashboard.title": "My Bookings",
    "cust.search": "Search businesses...",
    "cust.browse": "Browse Businesses",
    "cust.no_bookings": "No bookings yet. Browse businesses to make your first booking!",
    "cust.upcoming": "Upcoming",
    "cust.past": "Past",
    "book.select_date": "Select Date",
    "book.select_time": "Select Time",
    "book.phone": "Phone Number",
    "book.phone.placeholder": "Your phone number",
    "book.confirm": "Secure Your Spot",
    "book.available": "Available",
    "book.booked": "Booked",
    "book.deposit": "Deposit",
    "book.platform_fee": "Platform Fee",
    "book.total": "Total",
    "book.no_slots": "No available slots for this date",
    "book.closed": "Closed on this day",
    "avail.day.0": "Monday",
    "avail.day.1": "Tuesday",
    "avail.day.2": "Wednesday",
    "avail.day.3": "Thursday",
    "avail.day.4": "Friday",
    "avail.day.5": "Saturday",
    "avail.day.6": "Sunday",
    "avail.start": "Start Time",
    "avail.end": "End Time",
    "avail.duration": "Slot Duration (min)",
    "avail.working": "Working Day",
    "avail.save": "Save Availability",
    "pay.success": "Payment Successful!",
    "pay.success.desc": "Your booking has been confirmed.",
    "pay.processing": "Processing payment...",
    "pay.failed": "Payment failed. Please try again.",
    "pay.back": "Back to Dashboard",
    "status.pending_payment": "Pending Payment",
    "status.pending_satispay": "Awaiting Satispay",
    "status.confirmed": "Confirmed",
    "status.cancelled": "Cancelled",
    "status.completed": "Completed",
    "common.loading": "Loading...",
    "common.error": "Something went wrong",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.confirm": "Confirm",
    "common.back": "Back",
    "common.search": "Search",
    "common.no_results": "No results found",
    "common.book_now": "Book Now",
    "common.view": "View",
    "cancel.policy": "Cancellation allowed up to 1 hour before",
    "cancel.too_late": "Cannot cancel less than 1 hour before the appointment",
    "cancel.confirm": "Are you sure you want to cancel this booking?",
    "notif.title": "Notifications",
    "notif.empty": "No notifications",
    "notif.mark_read": "Mark all read",
    "admin.title": "Admin Dashboard",
    "admin.revenue": "Total Revenue",
    "admin.fees": "Platform Fees (1 EUR each)",
    "admin.transactions": "Transactions",
    "admin.businesses": "Businesses",
    "admin.users": "Users",
    "doc.upload": "Upload Verification Documents",
    "doc.upload.desc": "Upload your business documents (ID, license, registration) within 5 days",
    "doc.uploaded": "Document uploaded",
    "doc.select": "Select file",
    "landing.cta.customer": "Book an Appointment",
    "landing.paths.title": "Two Ways to Use BookEasy",
    "landing.path.customer.title": "For Customers",
    "landing.path.customer.desc": "Looking for a doctor, mechanic, spa, or restaurant? Find and book appointments instantly.",
    "landing.path.customer.f1": "Browse all registered businesses",
    "landing.path.customer.f2": "See real-time availability in the calendar",
    "landing.path.customer.f3": "Book and pay the deposit in seconds",
    "landing.path.business.title": "For Businesses",
    "landing.path.business.desc": "Manage your appointments, accept online bookings, and receive deposits automatically.",
    "landing.path.business.f1": "Set your availability and working hours",
    "landing.path.business.f2": "See customer names and phone numbers",
    "landing.path.business.f3": "Receive deposit payments automatically",
    "ai.panel.title": "Request Assistant",
    "ai.panel.desc": "Write your request and use AI to polish it",
    "ai.placeholder": "Describe your request (e.g., I need a haircut and beard trim...)",
    "ai.improve": "Improve with AI",
    "ai.improving": "Improving...",
    "ai.presets": "Quick Templates",
    "ai.presets.empty": "No templates available",
    "ai.presets.manage": "Manage Templates",
    "ai.presets.add": "Add Template",
    "ai.presets.title": "Template Title",
    "ai.presets.content": "Template Content",
    "ai.use": "Use this",
    "book.notes": "Special Requests",
    "book.notes.placeholder": "Any specific notes or requests?",
    "chat.title": "Chat",
    "chat.placeholder": "Write a message...",
    "chat.send": "Send",
    "chat.empty": "No messages yet. Start the conversation!",
    "chat.new": "New message",
    "block.title": "Blocked Slots",
    "block.add": "Block Slot",
    "block.date": "Date",
    "block.time": "Time (optional)",
    "block.reason": "Reason",
    "block.entire_day": "Entire day",
    "block.empty": "No blocked slots",
    "block.unblock": "Unblock",
    "tables.title": "Tables",
    "tables.setup": "Setup Tables",
    "tables.total": "Total Tables",
    "tables.number": "Table",
    "tables.available": "Available",
    "tables.occupied": "Occupied",
    "tables.free": "Free Table",
    "tables.occupy": "Occupy",
    "tables.freed_at": "Available since",
    "tables.empty": "No tables configured",
    "tables.setup.desc": "Set number of tables (1-100)",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Full Name",
    "auth.login": "Login",
    "auth.register": "Register",
    "auth.or": "or",
    "auth.no_account": "Don't have an account?",
    "auth.have_account": "Already have an account?",
    "auth.google": "Continue with Google",
    "auth.apple": "Continue with Apple",
    "auth.email_login": "Login with Email",
    "auth.email_register": "Register with Email",
    "menu.title": "Menu",
    "menu.add": "Add Item",
    "menu.name": "Name",
    "menu.price": "Price",
    "menu.description": "Description",
    "menu.category": "Category",
    "menu.daily_special": "Daily Special",
    "menu.empty": "No menu items",
    "menu.discount": "Daily Discount",
    "menu.discount.desc": "Apply discount to daily specials",
    "geo.nearby": "Nearby",
    "geo.distance": "Distance",
    "geo.enable": "Enable Location",
    "geo.searching": "Searching nearby...",
    "pizzeria.today_order": "Order for Today",
    "pizzeria.order_notes": "Notes for the Chef",
    "pizzeria.order_notes.placeholder": "e.g. Gluten free, extra cheese, no onions...",
    "pizzeria.select_pickup": "Select Pickup Time",
    "pizzeria.menu_title": "Our Menu",
    "pizzeria.your_order": "Your Order",
    "pizzeria.ticket": "Order Ticket",
    "pizzeria.ticket_number": "Order #",
    "pizzeria.pickup_at": "Pickup at",
    "pizzeria.orders_today": "Today's Orders",
    "pizzeria.no_orders": "No orders yet today",
    "book.confirm_friendly": "Complete Your Booking",
    "book.secure_spot": "Secure Your Spot",
    "book.almost_done": "Almost done! Confirm your details below.",
    "ai.assistant": "AI Assistant",
    "ai.assistant.desc": "Ask me anything about this business!",
    "ai.assistant.placeholder": "Ask about menu, hours, services...",
    "ai.assistant.thinking": "Thinking...",
    "ai.assistant.welcome": "Hi! I'm the AI assistant. Ask me about this business, the menu, available times, or anything else!",
    "ai.recommend": "AI Recommendations",
    "ai.recommend.desc": "Personalized suggestions just for you",
    "payment.method": "Payment Method",
    "payment.stripe": "Card Payment (Stripe)",
    "payment.satispay": "Satispay",
    "payment.satispay.desc": "Pay with Satispay app",
    "payment.satispay.pending": "Satispay not yet configured",
    "payment.choose": "Choose payment method",
    "cart.your_order": "Your Order",
    "cart.empty": "Cart is empty",
    "cart.clear": "Clear",
    "cart.subtotal": "Subtotal",
    "cart.order_now": "Order Now",
    "cart.select_time": "Select pickup time to proceed",
    "cart.add_item": "Add at least one item to cart!",
  },
  it: {
    "nav.home": "Home",
    "nav.dashboard": "Dashboard",
    "nav.login": "Accedi",
    "nav.logout": "Esci",
    "nav.delete_account": "Cancella Account",
    "nav.delete_account_confirm": "Questa azione non può essere annullata. Tutti i tuoi dati, prenotazioni e informazioni saranno eliminati definitivamente.",
    "landing.hero.overline": "LA PIATTAFORMA DI PRENOTAZIONE UNIVERSALE",
    "landing.hero.title": "Prenota appuntamenti, senza sforzo.",
    "landing.hero.subtitle": "Una piattaforma per ogni attivit\u00e0. Dai medici agli alberghi, meccanici alle spa. Prenota, paga, fatto.",
    "landing.cta": "Inizia Ora",
    "landing.cta.business": "Registra la Tua Attivit\u00e0",
    "landing.features.title": "Perch\u00e9 BookEasy",
    "landing.features.booking": "Prenotazione Facile",
    "landing.features.booking.desc": "Cerca attivit\u00e0, scegli un orario, prenota subito con il calendario condiviso.",
    "landing.features.payments": "Pagamenti Sicuri",
    "landing.features.payments.desc": "Paga la cauzione in modo sicuro tramite Stripe. La tua prenotazione \u00e8 garantita.",
    "landing.features.global": "Pronto per il Mondo",
    "landing.features.global.desc": "Disponibile in 5 lingue. Funziona per attivit\u00e0 e clienti in tutto il mondo.",
    "landing.features.categories": "Ogni Categoria",
    "landing.features.categories.desc": "Medici, dentisti, alberghi, spa, meccanici, ristoranti e altro.",
    "landing.how.title": "Come Funziona",
    "landing.how.step1": "Crea Account",
    "landing.how.step1.desc": "Registrati con Google in pochi secondi.",
    "landing.how.step2": "Trova e Prenota",
    "landing.how.step2.desc": "Cerca attivit\u00e0, scegli data e ora.",
    "landing.how.step3": "Tutto Pronto!",
    "landing.how.step3.desc": "Una piccola cauzione conferma il tuo posto. Facile e sicuro!",
    "cat.medical": "Medico",
    "cat.dental": "Dentista",
    "cat.mechanic": "Meccanico",
    "cat.locksmith": "Fabbro",
    "cat.hotel": "Albergo",
    "cat.spa": "Spa",
    "cat.restaurant": "Ristorante",
    "cat.beauty": "Bellezza",
    "cat.fitness": "Fitness",
    "cat.veterinary": "Veterinario",
    "cat.hairdresser": "Parrucchiere",
    "cat.private_clinic": "Clinica Privata",
    "cat.pizzeria": "Pizzeria / Asporto",
    "cat.bar": "Bar / Pub",
    "cat.parking": "Parcheggio",
    "cat.lawyer": "Avvocato",
    "cat.accountant": "Commercialista",
    "cat.notary": "Notaio",
    "cat.architect": "Architetto",
    "cat.engineer": "Ingegnere",
    "cat.psychologist": "Psicologo",
    "cat.physiotherapist": "Fisioterapista",
    "cat.optician": "Ottico",
    "cat.pharmacy": "Farmacia",
    "cat.tailor": "Sarto",
    "cat.plumber": "Idraulico",
    "cat.electrician": "Elettricista",
    "cat.painter": "Imbianchino",
    "cat.carpenter": "Falegname",
    "cat.driving_school": "Autoscuola",
    "cat.photographer": "Fotografo",
    "cat.florist": "Fiorista",
    "cat.bakery": "Panetteria / Pasticceria",
    "cat.butcher": "Macelleria",
    "cat.ice_cream": "Gelateria",
    "cat.sushi": "Sushi",
    "cat.kebab": "Kebab",
    "cat.takeaway_pizza": "Pizza da Asporto",
    "cat.coworking": "Coworking",
    "cat.laundry": "Lavanderia",
    "cat.pet_grooming": "Toelettatura Animali",
    "cat.tattoo": "Studio Tatuaggi",
    "cat.barber": "Barbiere",
    "cat.beach_club": "Bagni al Mare",
    "cat.other": "Altro",
    "cat.all": "Tutte le Categorie",
    "role.title": "Come userai BookEasy?",
    "role.customer": "Voglio prenotare appuntamenti",
    "role.customer.desc": "Trova attivit\u00e0 e prenota servizi",
    "role.customer.label": "Cliente",
    "role.business": "Ho un'attivit\u00e0",
    "role.business.desc": "Gestisci appuntamenti e accetta prenotazioni",
    "role.business.label": "Attivit\u00e0",
    "biz.register.title": "Registra la Tua Attivit\u00e0",
    "biz.name": "Nome Attivit\u00e0",
    "biz.category": "Categoria",
    "biz.description": "Descrizione",
    "biz.address": "Indirizzo",
    "biz.phone": "Telefono",
    "biz.deposit": "Importo Cauzione (EUR)",
    "biz.submit": "Registra Attivit\u00e0",
    "biz.dashboard.title": "Dashboard Attivit\u00e0",
    "biz.bookings": "Prenotazioni",
    "biz.availability": "Disponibilit\u00e0",
    "biz.settings": "Impostazioni",
    "biz.today": "Prenotazioni di Oggi",
    "biz.total": "Prenotazioni Totali",
    "biz.no_bookings": "Nessuna prenotazione",
    "cust.dashboard.title": "Le Mie Prenotazioni",
    "cust.search": "Cerca attivit\u00e0...",
    "cust.browse": "Sfoglia Attivit\u00e0",
    "cust.no_bookings": "Nessuna prenotazione. Sfoglia le attivit\u00e0 per la tua prima prenotazione!",
    "cust.upcoming": "Prossimi",
    "cust.past": "Passati",
    "book.select_date": "Seleziona Data",
    "book.select_time": "Seleziona Orario",
    "book.phone": "Numero di Telefono",
    "book.phone.placeholder": "Il tuo numero di telefono",
    "book.confirm": "Prenota il tuo Posto",
    "book.available": "Disponibile",
    "book.booked": "Prenotato",
    "book.deposit": "Cauzione",
    "book.platform_fee": "Commissione Piattaforma",
    "book.total": "Totale",
    "book.no_slots": "Nessuno slot disponibile per questa data",
    "book.closed": "Chiuso in questo giorno",
    "avail.day.0": "Luned\u00ec",
    "avail.day.1": "Marted\u00ec",
    "avail.day.2": "Mercoled\u00ec",
    "avail.day.3": "Gioved\u00ec",
    "avail.day.4": "Venerd\u00ec",
    "avail.day.5": "Sabato",
    "avail.day.6": "Domenica",
    "avail.start": "Orario Inizio",
    "avail.end": "Orario Fine",
    "avail.duration": "Durata Slot (min)",
    "avail.working": "Giorno Lavorativo",
    "avail.save": "Salva Disponibilit\u00e0",
    "pay.success": "Pagamento Riuscito!",
    "pay.success.desc": "La tua prenotazione \u00e8 stata confermata.",
    "pay.processing": "Elaborazione pagamento...",
    "pay.failed": "Pagamento fallito. Riprova.",
    "pay.back": "Torna alla Dashboard",
    "status.pending_payment": "In Attesa di Pagamento",
    "status.pending_satispay": "In Attesa Satispay",
    "status.confirmed": "Confermato",
    "status.cancelled": "Cancellato",
    "status.completed": "Completato",
    "common.loading": "Caricamento...",
    "common.error": "Qualcosa \u00e8 andato storto",
    "common.save": "Salva",
    "common.cancel": "Annulla",
    "common.confirm": "Conferma",
    "common.back": "Indietro",
    "common.search": "Cerca",
    "common.no_results": "Nessun risultato",
    "common.book_now": "Prenota Ora",
    "common.view": "Visualizza",
    "cancel.policy": "Cancellazione possibile fino a 1 ora prima",
    "cancel.too_late": "Non puoi cancellare a meno di 1 ora dall'appuntamento",
    "cancel.confirm": "Sei sicuro di voler cancellare questa prenotazione?",
    "notif.title": "Notifiche",
    "notif.empty": "Nessuna notifica",
    "notif.mark_read": "Segna tutte come lette",
    "admin.title": "Dashboard Admin",
    "admin.revenue": "Fatturato Totale",
    "admin.fees": "Commissioni Piattaforma (1 EUR ciascuna)",
    "admin.transactions": "Transazioni",
    "admin.businesses": "Attivit\u00e0",
    "admin.users": "Utenti",
    "doc.upload": "Carica Documenti di Verifica",
    "doc.upload.desc": "Carica i documenti della tua attivit\u00e0 (carta d'identit\u00e0, licenza, registrazione) entro 5 giorni",
    "doc.uploaded": "Documento caricato",
    "doc.select": "Seleziona file",
    "landing.cta.customer": "Prenota un Appuntamento",
    "landing.paths.title": "Due Modi per Usare BookEasy",
    "landing.path.customer.title": "Per i Clienti",
    "landing.path.customer.desc": "Cerchi un medico, meccanico, spa o ristorante? Trova e prenota appuntamenti subito.",
    "landing.path.customer.f1": "Sfoglia tutte le attivit\u00e0 registrate",
    "landing.path.customer.f2": "Vedi la disponibilit\u00e0 in tempo reale nel calendario",
    "landing.path.customer.f3": "Prenota e paga la cauzione in pochi secondi",
    "landing.path.business.title": "Per le Attivit\u00e0",
    "landing.path.business.desc": "Gestisci i tuoi appuntamenti, accetta prenotazioni online e ricevi cauzioni automaticamente.",
    "landing.path.business.f1": "Imposta la tua disponibilit\u00e0 e orari di lavoro",
    "landing.path.business.f2": "Vedi nomi e numeri di telefono dei clienti",
    "landing.path.business.f3": "Ricevi pagamenti cauzione automaticamente",
    "ai.panel.title": "Assistente Richieste",
    "ai.panel.desc": "Scrivi la tua richiesta e usa l'IA per migliorarla",
    "ai.placeholder": "Descrivi la tua richiesta (es. Ho bisogno di un taglio e barba...)",
    "ai.improve": "Migliora con IA",
    "ai.improving": "Miglioramento...",
    "ai.presets": "Template Rapidi",
    "ai.presets.empty": "Nessun template disponibile",
    "ai.presets.manage": "Gestisci Template",
    "ai.presets.add": "Aggiungi Template",
    "ai.presets.title": "Titolo Template",
    "ai.presets.content": "Contenuto Template",
    "ai.use": "Usa questo",
    "book.notes": "Richieste Speciali",
    "book.notes.placeholder": "Hai note o richieste specifiche?",
    "chat.title": "Chat",
    "chat.placeholder": "Scrivi un messaggio...",
    "chat.send": "Invia",
    "chat.empty": "Nessun messaggio. Inizia la conversazione!",
    "chat.new": "Nuovo messaggio",
    "block.title": "Slot Bloccati",
    "block.add": "Blocca Slot",
    "block.date": "Data",
    "block.time": "Orario (opzionale)",
    "block.reason": "Motivo",
    "block.entire_day": "Giornata intera",
    "block.empty": "Nessuno slot bloccato",
    "block.unblock": "Sblocca",
    "tables.title": "Tavoli",
    "tables.setup": "Configura Tavoli",
    "tables.total": "Numero Tavoli",
    "tables.number": "Tavolo",
    "tables.available": "Disponibile",
    "tables.occupied": "Occupato",
    "tables.free": "Libera Tavolo",
    "tables.occupy": "Occupa",
    "tables.freed_at": "Libero dalle",
    "tables.empty": "Nessun tavolo configurato",
    "tables.setup.desc": "Imposta numero tavoli (1-100)",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Nome Completo",
    "auth.login": "Accedi",
    "auth.register": "Registrati",
    "auth.or": "oppure",
    "auth.no_account": "Non hai un account?",
    "auth.have_account": "Hai già un account?",
    "auth.google": "Continua con Google",
    "auth.apple": "Continua con Apple",
    "auth.email_login": "Accedi con Email",
    "auth.email_register": "Registrati con Email",
    "menu.title": "Menu",
    "menu.add": "Aggiungi Prodotto",
    "menu.name": "Nome",
    "menu.price": "Prezzo",
    "menu.description": "Descrizione",
    "menu.category": "Categoria",
    "menu.daily_special": "Piatto del Giorno",
    "menu.empty": "Nessun prodotto nel menu",
    "menu.discount": "Sconto Menu del Giorno",
    "menu.discount.desc": "Applica sconto ai piatti del giorno",
    "geo.nearby": "Nelle vicinanze",
    "geo.distance": "Distanza",
    "geo.enable": "Attiva Posizione",
    "geo.searching": "Cercando nelle vicinanze...",
    "pizzeria.today_order": "Ordina per Oggi",
    "pizzeria.order_notes": "Note per il Pizzaiolo",
    "pizzeria.order_notes.placeholder": "es. Senza glutine, extra mozzarella, senza cipolla...",
    "pizzeria.select_pickup": "Scegli Orario Ritiro",
    "pizzeria.menu_title": "Il Nostro Menu",
    "pizzeria.your_order": "Il Tuo Ordine",
    "pizzeria.ticket": "Comanda",
    "pizzeria.ticket_number": "Comanda #",
    "pizzeria.pickup_at": "Ritiro alle",
    "pizzeria.orders_today": "Ordini di Oggi",
    "pizzeria.no_orders": "Nessun ordine per oggi",
    "book.confirm_friendly": "Conferma la tua Prenotazione",
    "book.secure_spot": "Prenota il tuo Posto",
    "book.almost_done": "Ci siamo quasi! Conferma i tuoi dati qui sotto.",
    "ai.assistant": "Assistente IA",
    "ai.assistant.desc": "Chiedimi qualsiasi cosa su questa attività!",
    "ai.assistant.placeholder": "Chiedi del menu, orari, servizi...",
    "ai.assistant.thinking": "Sto pensando...",
    "ai.assistant.welcome": "Ciao! Sono l'assistente IA. Chiedimi del menu, degli orari disponibili, dei servizi o qualsiasi altra cosa!",
    "ai.recommend": "Consigli IA",
    "ai.recommend.desc": "Suggerimenti personalizzati per te",
    "payment.method": "Metodo di Pagamento",
    "payment.stripe": "Pagamento con Carta (Stripe)",
    "payment.satispay": "Satispay",
    "payment.satispay.desc": "Paga con l'app Satispay",
    "payment.satispay.pending": "Satispay non ancora configurato",
    "payment.choose": "Scegli metodo di pagamento",
    "cart.your_order": "Il tuo Ordine",
    "cart.empty": "Carrello vuoto",
    "cart.clear": "Svuota",
    "cart.subtotal": "Subtotale",
    "cart.order_now": "Ordina Ora",
    "cart.select_time": "Scegli un orario di ritiro per procedere",
    "cart.add_item": "Aggiungi almeno un prodotto al carrello!",
  },
  es: {
    "nav.home": "Inicio",
    "nav.dashboard": "Panel",
    "nav.login": "Iniciar Sesi\u00f3n",
    "nav.logout": "Cerrar Sesi\u00f3n",
    "landing.hero.overline": "LA PLATAFORMA DE RESERVAS UNIVERSAL",
    "landing.hero.title": "Reserva citas, sin esfuerzo.",
    "landing.hero.subtitle": "Una plataforma para cada negocio. Desde m\u00e9dicos hasta hoteles. Reserva, paga, listo.",
    "landing.cta": "Comenzar",
    "landing.cta.business": "Registra Tu Negocio",
    "cat.medical": "M\u00e9dico",
    "cat.dental": "Dental",
    "cat.mechanic": "Mec\u00e1nico",
    "cat.locksmith": "Cerrajero",
    "cat.hotel": "Hotel",
    "cat.spa": "Spa",
    "cat.restaurant": "Restaurante",
    "cat.beauty": "Belleza",
    "cat.fitness": "Fitness",
    "cat.veterinary": "Veterinario",
    "cat.other": "Otro",
    "cat.all": "Todas las Categor\u00edas",
    "role.title": "\u00bfC\u00f3mo usar\u00e1s BookEasy?",
    "role.customer": "Quiero reservar citas",
    "role.customer.desc": "Encuentra negocios y reserva servicios",
    "role.business": "Tengo un negocio",
    "role.business.desc": "Gestiona citas y acepta reservas",
    "common.loading": "Cargando...",
    "common.book_now": "Reservar Ahora",
  },
  fr: {
    "nav.home": "Accueil",
    "nav.dashboard": "Tableau de Bord",
    "nav.login": "Connexion",
    "nav.logout": "D\u00e9connexion",
    "landing.hero.overline": "LA PLATEFORME DE R\u00c9SERVATION UNIVERSELLE",
    "landing.hero.title": "R\u00e9servez des rendez-vous, facilement.",
    "landing.hero.subtitle": "Une plateforme pour chaque entreprise. Des m\u00e9decins aux h\u00f4tels. R\u00e9servez, payez, c'est fait.",
    "landing.cta": "Commencer",
    "landing.cta.business": "Enregistrez Votre Entreprise",
    "cat.medical": "M\u00e9dical",
    "cat.dental": "Dentaire",
    "cat.mechanic": "M\u00e9canicien",
    "cat.locksmith": "Serrurier",
    "cat.hotel": "H\u00f4tel",
    "cat.spa": "Spa",
    "cat.restaurant": "Restaurant",
    "cat.beauty": "Beaut\u00e9",
    "cat.fitness": "Fitness",
    "cat.veterinary": "V\u00e9t\u00e9rinaire",
    "cat.other": "Autre",
    "cat.all": "Toutes les Cat\u00e9gories",
    "role.title": "Comment utiliserez-vous BookEasy?",
    "role.customer": "Je veux prendre des rendez-vous",
    "role.customer.desc": "Trouvez des entreprises et r\u00e9servez",
    "role.business": "J'ai une entreprise",
    "role.business.desc": "G\u00e9rez les rendez-vous et acceptez les r\u00e9servations",
    "common.loading": "Chargement...",
    "common.book_now": "R\u00e9server",
  },
  de: {
    "nav.home": "Startseite",
    "nav.dashboard": "Dashboard",
    "nav.login": "Anmelden",
    "nav.logout": "Abmelden",
    "landing.hero.overline": "DIE UNIVERSELLE BUCHUNGSPLATTFORM",
    "landing.hero.title": "Termine buchen, m\u00fchelos.",
    "landing.hero.subtitle": "Eine Plattform f\u00fcr jedes Unternehmen. Von \u00c4rzten bis Hotels. Buchen, bezahlen, fertig.",
    "landing.cta": "Loslegen",
    "landing.cta.business": "Registrieren Sie Ihr Unternehmen",
    "cat.medical": "Medizin",
    "cat.dental": "Zahnarzt",
    "cat.mechanic": "Mechaniker",
    "cat.locksmith": "Schlosser",
    "cat.hotel": "Hotel",
    "cat.spa": "Spa",
    "cat.restaurant": "Restaurant",
    "cat.beauty": "Sch\u00f6nheit",
    "cat.fitness": "Fitness",
    "cat.veterinary": "Tierarzt",
    "cat.other": "Andere",
    "cat.all": "Alle Kategorien",
    "role.title": "Wie werden Sie BookEasy nutzen?",
    "role.customer": "Ich m\u00f6chte Termine buchen",
    "role.customer.desc": "Unternehmen finden und Termine buchen",
    "role.business": "Ich habe ein Unternehmen",
    "role.business.desc": "Termine verwalten und Buchungen akzeptieren",
    "common.loading": "Laden...",
    "common.book_now": "Jetzt Buchen",
  },
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem("bookeasy_lang");
    return saved || "it";
  });

  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("bookeasy_lang", lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider");
  return context;
}
